import * as yup from 'yup'
import { useIntl } from 'react-intl'
import { cpf, cnpj } from '@client/utils/validation'

export default function useValidation(fields, intl = useIntl()) {
  const yupObject = {}

  const numberValidation =
    intl.messages['smb_acquisition_form.fields.validations.numbers_only']

  fields.forEach(elem => {
    let yupField

    if (elem.customValidations) {
      elem.customValidations.forEach(val => {
        yup.addMethod(val.type, val.key, function(message) {
          return this.test(val.key, message, val.test)
        })
      })
    }

    if (elem.validations) {
      yupField = yup

      if (elem.validations.primitiveType === 'string') {
        yupField = yupField.string()
      }
      if (elem.validations.primitiveType === 'number') {
        yupField = yupField.number()
      }
      if (elem.validations.primitiveType === 'boolean') {
        yupField = yupField.boolean()
      }
      if (elem.validations.employeesNumberInRange) {
        yupField = yupField.employeesNumberInRange(
          intl.messages[
            'smb_acquisition_form.fields.validations.employeesNumberInRange'
          ]
        )
      }
      if (elem.validations.notEqualBrokerEmail) {
        yupField = yupField.notEqualBrokerEmail(
          intl.messages[
            'smb_acquisition_form.fields.validations.notEqualBrokerEmail'
          ]
        )
      }
      if (elem.validations.notEqualClientEmail) {
        yupField = yupField.notEqualClientEmail(
          intl.messages[
            'smb_acquisition_form.fields.validations.notEqualClientEmail'
          ]
        )
      }

      const {
        required,
        typeError,
        noHtmlTag,
        email,
        min,
        isCpf,
        isCnpj,
        positive,
        integer,
        phone,
      } = elem.validations

      if (required) {
        if (elem.validations.primitiveType === 'boolean') {
          yupField = yupField.oneOf(
            [true],
            intl.messages['smb_acquisition_form.fields.validations.required']
          )
        } else {
          yupField = yupField.required(
            intl.messages['smb_acquisition_form.fields.validations.required']
          )
        }
      }
      if (noHtmlTag) {
        yupField = yupField.matches(
          /^((?!<*>).)*$/g,
          intl.messages['smb_acquisition_form.fields.validations.no_html_tag']
        )
      }

      if (email) {
        yupField = yupField.email(
          intl.messages['smb_acquisition_form.fields.validations.email.invalid']
        )
      }
      if (min) {
        yupField = yupField.min(
          min,
          intl.messages[
            ('smb_acquisition_form.fields.validations.phone.minlength', { min })
          ]
        )
      }
      if (isCpf) {
        yupField = yupField.test(
          'cpf-is-correct',
          intl.messages['smb_acquisition_form.fields.validations.cpf.invalid'],
          value => value && cpf(value)
        )
      }
      if (isCnpj) {
        yupField = yupField.test(
          'cnpj-is-correct',
          intl.messages['smb_acquisition_form.fields.validations.cnpj.invalid'],
          value => value && cnpj(value)
        )
      }

      if (positive) {
        yupField = yupField.positive(numberValidation)
      }

      if (integer) {
        yupField = yupField.integer(numberValidation)
      }

      if (phone && min) {
        yupField = yupField
          .transform(value => value.replace(/[^\d]/g, ''))
          .min(
            min,
            intl.messages[
              'smb_acquisition_form.fields.validations.phone.minlength'
            ]
          )
      }

      if (phone && elem.validations.matches) {
        yupField = yupField.matches(
          /^(?:(?:\+|00)?(55)\s?)?(?:\(?([1-9][0-9])\)?\s?)?(?:((?:9\d|[2-9])\d{3})-?(\d{4}))/,
          intl.messages['smb_acquisition_form.fields.validations.phone.matches']
        )
      }

      if (typeError && elem.validations.primitiveType === 'number') {
        yupField = yupField.typeError(numberValidation)
      }
    }

    if (yupField) {
      yupObject[elem.name] = yupField
    }
  })

  const schema = yup.object().shape(yupObject)

  return schema
}
